import { COLORS } from '@constants';
import styled from 'styled-components';

export const StyledNotificationsWrapper = styled.div`
    width: 100%;
    max-width: 1328px;
    margin: 0 auto;
    padding: 48px 24px 0;

    a {
        color: ${COLORS.$info};
    }
`;
